import React, { useState, useEffect, useContext, useRef } from "react";
import { Search, User, ShoppingBag, Menu, X, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { data, useNavigate } from "react-router-dom";
import { MyContext } from "../../context/MyContext";
import ProfileDropdown from "./ProfileDropdown";
import { getData, postData, serverURL } from "../../services/NodeServices";

const NavbarTailwind = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const [isTop, setIsTop] = useState(true);

   const isTopFunction = () => {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    return scrollY <= 10;
  };

  


  const [searchText,setSearchText]=useState('')

  
  const { cart,isloggedIn,user } = useContext(MyContext);
  const cartLength = cart?.length || "";

  const navigate = useNavigate();



    const [catlist,setCatList]=useState([])
  
  
    const fetchCategoryList=async()=>{
      try{
        const result = await getData('api/productcategory/catlist')
  
        if(result.status){
          console.log(result)
          setCatList(result.data.cat)
        }
      }
      catch{
  
  
      }
    }
  



  useEffect(() => {

    

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 5);
      setIsTop(isTopFunction())
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleProfileClick = () => {
    // Handle profile click logic here
    navigate("/log-in");
  };

  const handleClickCart = () => {
    // Handle cart click logic here
    navigate("/cart");
  };

  const [isNotAtTop, setIsNotAtTop] = useState(false);
  const [scrollY, setScrollY] = useState(0);


    useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      setIsNotAtTop(currentScrollY > 0);
    };

    // Add event listener
    window.addEventListener('scroll', handleScroll);

    // Check initial position
    handleScroll();

    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);



  console.log("user scrolled ", isNotAtTop);

  const handleMobileNavigate=(item)=>{
      
    setIsMobileMenuOpen(false)
    navigate(`category/${item.productcategoryname}/All`)

  }

   const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const searchInp= useRef(null);
  
      const [suggestions, setSuggestions] = useState([]);
      const [showSuggestions, setShowSuggestions] = useState(false);

      useEffect(() => {
    if (showSuggestions) {
    
    } else {
      document.body.style.overflow = ""; // Unlock scroll
    }

    return () => {
      document.body.style.overflow = ""; // Ensure unlock on unmount
    };
  }, [showSuggestions]);
   const hideSuggestions = () => {
    setShowSuggestions(false);
    setSuggestions([]);
    document.body.style.overflow = ""; // Unlock scroll
  };

   useEffect(() => {
    fetchCategoryList()
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 5);
      
      // Hide suggestions when user scrolls
      if (showSuggestions) {
        hideSuggestions();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showSuggestions]);

    useEffect(() => {
    
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 5);
      console.log(isScrolled)

    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const handleSearch = (e) => {
        console.log('fetching ')
        const query = e.target.value;
        setSearchQuery(query);
    
        if (query.trim()) {
          fetchSuggestions(query);
        } else {
          setSuggestions([]);
          setShowSuggestions(false)
        }
      };
    
      useEffect(() => {
        if (showSuggestions) {
        
        } else {
          document.body.style.overflow = ""; // Unlock scroll
        }
    
        return () => {
          document.body.style.overflow = ""; // Ensure unlock on unmount
        };
      }, [showSuggestions]);
    
      const fetchSuggestions = async (query) => {
        try {
          // Replace this with your API call
          const response = await postData('api/products/suggest',{query:query})
        
         
         if(response.status){
          setSuggestions(response.data);
          setShowSuggestions(true);
          console.log('fetching rsultssssssssssssssssssssssssssssssss',response.data)
         
         }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
        }
      };


      const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setShowSuggestions(false)
      document.body.style.overflow = ""; // Unlock scroll
      
     navigate(`/search/${searchQuery}`)

     
    }
  };



  
  return (
    <>
      {/* Top Banner */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className=" bg-slate-700 text-white text-center py-1 px-2 text-sm fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      >
        <span className="text-xs font-light">
          Free shipping to India on all orders above ₹25,270.00
        </span>
        <button className="absolute right-4 top-1/2 transform -translate-y-1/2 hover:opacity-70 transition-opacity">
          <X size={16} />
        </button>
      </motion.div>

      {/* Main Navbar */}
      <motion.nav
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        style={{
          top: "25px !important",
          left: "0 !important",
          right: "0 !important",
        }}
        className={` bg-white border-gray-100  z-50 fixed !important transition-all duration-300 fixed top-[25px] left-0 right-0 z-50 transition-all max-sm:top-0 duration-300${
          isScrolled ? "shadow-s" : "top-0"
        }`}
      >
        <div className=" mx-auto px-2 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Left Section - Country/Language Selector (Desktop) */}
            <div className="hidden lg:flex items-center space-x-6 ml-4">
              <motion.button
                whileHover={{ scale: 1.02 }}
                className="flex items-center space-x-2 text-sm text-gray-700 hover:text-gray-900 transition-colors"
              >
                <span>India (INR ₹)</span>
                <ChevronDown size={14} />
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                className="flex items-center space-x-2 text-sm text-gray-700 hover:text-gray-900 transition-colors"
              >
                <span>English</span>
                <ChevronDown size={14} />
              </motion.button>
            </div>

            {/* Mobile Menu Button */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 text-gray-700 hover:text-gray-900"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </motion.button>

            {/* Center Logo */}
           {<a href="/"><motion.div className=" flex justify-center ml-[161px] scale-75  max-sm:ml-[52px]">
              <img
                src="/blaze.png" // Replace with your logo path
                alt="Logo"
                className="h-8 lg:h-10 w-auto"
              />
            </motion.div>
            </a> }

            {/* Right Section - Icons */}
            <div className="flex items-center">
              <motion.button
               
                
                className="p-2 text-gray-700 hover:text-gray-900 transition-colors"
              >
              <div className="lg:hidden">  <a href={`/search`}><Search size={20} /></a></div>
              <div className=" relative max-lg:hidden bg-[#f2f2f2] flex flex-row justify-start items-center rounded-full pl-3">
                <Search size={20} /><input className="w-[251px]  h-[41px] rounded-full ml-3 text-[17px]" value={searchQuery} onKeyDown={(e)=>{handleKeyDown(e)}} onChange={(e)=>{handleSearch(e)}} type="text" /> 
                
                {showSuggestions&&suggestions.length>=1&&
                <div className="absolute z-2222 px-4 py-[7px] top-[51px] bottom-[151px] w-full bg-[#fff] shadow-md rounded-md h-[fit-content] flex-col w-full justify-center items-center">
                 {suggestions.map((item)=>{
                  return(
                    <div className="w-full text-left text-[13px] my-2 hover:text-[#222] hover:font-semibold" onClick={()=>{navigate(`/search/${item}`);
                                                                                                                           setShowSuggestions(false);
                                                                                                                           
                  }} >{item}</div>
                  )
                 })}
                </div>
                }
                
                </div>
              </motion.button>
              <ProfileDropdown
                isLoggedIn={isloggedIn}
                navigate={navigate}
                user={user}
              />
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className="p-2 text-gray-700 hover:text-gray-900 transition-colors relative"
              >
                <ShoppingBag size={20} onClick={handleClickCart} />
                {cartLength && cartLength > 0 && (
                  <span className="absolute -top-1 -right-1 bg-gray-900 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                    {cartLength > 0 ? cartLength : ""}
                  </span>
                )}
              </motion.button>
            </div>
          </div>

          {/* Desktop Navigation Menu */}
          <div className=" lg:block border-t border-gray-100">
           
            <div className="flex justify-center space-x-12 py-2">
              {catlist.length>=1&&catlist&&catlist?.map(
                (item) => (
                  <motion.a
                    key={item}
                    href=""
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    whileHover={{ scale: 1.05 }}
                    className="text-sm font-medium text-gray-700 hover:text-gray-900 tracking-wide transition-colors relative group"
                  
                  onClick={()=>{navigate(`/category/${item.productcategoryname}/All`)}}
                  >
                    {console.log(catlist)}
                    {item.productcategoryname}
                    <motion.div
                      className="absolute bottom-0 left-0 w-0 h-0.5 bg-gray-900 group-hover:w-full transition-all duration-300"
                      whileHover={{ width: "100%" }}
                    />
                  </motion.a>
                )
              )}
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <AnimatePresence>
          {isMobileMenuOpen && (
            <>
              {/* Backdrop */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                onClick={() => setIsMobileMenuOpen(false)}
              />


              {/* Side Menu */}
              <motion.div
                initial={{ x: "-100%" }}
                animate={{ x: 0 }}
                exit={{ x: "-100%" }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="fixed top-0 left-0 h-full w-80 bg-white shadow-xl z-50 lg:hidden overflow-y-auto"
              >
                <div className="p-6">
                  {/* Close Button */}
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-light tracking-wider text-gray-900">
                      MENU
                    </h2>
                    <motion.button
                      whileTap={{ scale: 0.95 }}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="p-2 text-gray-700 hover:text-gray-900"
                    >
                      <X size={24} />
                    </motion.button>

                   
                  </div>

                  

                  {/* Mobile Country/Language Selectors */}
                 

                   <div className="flex flex-col justify-start item-start w-full">
                   
                   
                   <div className="flex flex-col justify-start items-start">
                 <a href="/">  <p className="text-sm mb-2 text-left">home</p></a>
                   <a href="/userinfo"> <p className="text-sm mb-2 text-left mt-2">profile</p></a>
                   <a href="/orders"> <p className="text-sm mb-2 text-left mt-2">orders</p></a>
                  </div>

                  </div>


                  <div className="text-lg text-[#333] mt-6 mb-2 text-left">CATEGORIES</div>

                  {/* Mobile Navigation Links */}
                  <div className="space-y-2 p-1" style={{ padding: "0rem" }}>
                    {catlist?.map(
                      (item, index) => (
                        <motion.a
                          key={item}
                          href="#"
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.1 * index }}
                          whileHover={{ x: 5 }}
                          className="block text-sm text-left text-gray-700 hover:text-gray-900 tracking-wide transition-all py-1"
                          onClick={() => {handleMobileNavigate(item)}}
                        >
                          {item.productcategoryname}
                        </motion.a>
                      )
                    )}
                  </div>
                </div>
                 <div className="space-y-4 pb-6 border-b border-gray-100 mb-6 px-4">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      className="flex items-center justify-between w-full text-left text-sm text-gray-700"
                    >
                      <span>India (INR ₹)</span>
                      <ChevronDown size={14} />
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      className="flex items-center justify-between w-full text-left text-sm text-gray-700"
                    >
                      <span>English</span>
                      <ChevronDown size={14} />
                    </motion.button>
                  </div>
              </motion.div>
            </>
          )}
        </AnimatePresence>
      </motion.nav>

      {/* Demo Content */}
    </>
  );
};

export default NavbarTailwind;
